import React from 'react'
import {Tab, Tabs} from 'react-bootstrap'
import {useParams} from 'react-router-dom'
import {
  useGetDetailBatchQuery,
  useGetErrorDetailBatchQuery,
} from '../../../../../redux/api/services/batch'
import {TitleCard} from '../../../../../helpers/elements/card/TitleCard'
import CustomTable from '../../../../../helpers/elements/table/CustomTable'
import {
  detailsColumns,
  errorDetailColumns,
} from '../../../../../helpers/elements/table/columns/_columns'
import {useSelector} from 'react-redux'
import {RootState} from '../../../../../redux/store'
import {CustomErrorAlert} from '../../../../../libs/_fri/components/CustomErrorAlert/CustomErrorAlert'

export const BatchDetail = () => {
  const {id} = useParams()
  const infoState = useSelector((state: RootState) => state.info)

  const detailBatchStatus = useGetDetailBatchQuery({
    info: infoState,
    requestContent: {batchId: id || ''},
  })

  const detailBatchErrorStatus = useGetErrorDetailBatchQuery({
    info: infoState,
    requestContent: {batchId: id || ''},
  })

  return (
    <>
      <TitleCard title='Pagos programados' subtitle='Listado de pagos' goBack='/scheduled/list' />
      <div className='card'>
        <div className='card-body'>
          {id && (
            <Tabs defaultActiveKey='schedule' className='mb-3'>
              <Tab
                eventKey='schedule'
                className='mt-14'
                title={`Pagos a realizar (${
                  detailBatchStatus.data?.responseContent.records.length || 0
                })`}
              >
                <CustomErrorAlert
                  show={detailBatchStatus.isError}
                  error={detailBatchStatus.error}
                />

                <CustomTable
                  batchList={detailBatchStatus.data?.responseContent.records || []}
                  isLoading={detailBatchStatus.isLoading}
                  columns={detailsColumns}
                />
              </Tab>
              <Tab
                eventKey='batchErrorsDetail'
                title={`Registos inválidos (${
                  detailBatchErrorStatus.data?.responseContent.errors.length || 0
                })`}
              >
                <CustomErrorAlert
                  show={detailBatchErrorStatus.isError}
                  error={detailBatchErrorStatus.error}
                />
                <CustomTable
                  batchList={detailBatchErrorStatus.data?.responseContent.errors || []}
                  isLoading={detailBatchErrorStatus.isLoading}
                  columns={errorDetailColumns}
                />
              </Tab>
            </Tabs>
          )}
        </div>
      </div>
    </>
  )
}
